export function worker(): Worker {
  if (typeof Worker !== 'undefined') {
    const worker = new Worker(new URL('./save-workflow-config-worker.worker', import.meta.url), {
      type: 'module',
    });
    return worker;
  } else {
    throw Error('workers not supported');
  }
}
